import NewPassword from './NewPassword'
import enhance from './NewPassword.enhancer'

export default enhance(NewPassword)



// WEBPACK FOOTER //
// ./src/containers/account/NewPassword/index.js